export const shouldAutoFill = (autoFill?: boolean) => {
  if (autoFill === true) {
    return 'on';
  } else if (autoFill === false) {
    // @TODO - autocomplete="off" is now ignored by most browsers, consider 'new-password'
    return 'off';
  }

  return undefined;
};
